module.exports = __webpack_public_path__ + "static/assets/396265488439fb775f378e7e1cd517a6.svg";